import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'M Y J trabajo en alturas';
}



// WEBPACK FOOTER //
// /home/xpro/Documentos/ances/myjangular/src/app/app.component.ts